import React from 'react';
import { formatTimestamp, getTimeSince, getRefreshIntervalText } from '../../utils';

/**
 * Device header card component
 */
export const DeviceCard = ({
  latestData,
  lastUpdate,
  currentTime,
  messageCount,
  historyLength,
  refreshInterval
}) => {
  return (
    <div className="device-card fade-in">
      <div className="device-header">
        <div className="device-info">
          <div className="device-icon">🖥️</div>
          <div className="device-info-text">
            <div className="device-name">{latestData.code}</div>
            <div className="device-timestamp">{formatTimestamp(lastUpdate)}</div>
          </div>
        </div>
        <div className="device-stats">
          <div className="stat-item stat-time">
            <div className="stat-icon">🕐</div>
            <div className="stat-content">
              <div className="stat-value">{getTimeSince(lastUpdate, currentTime)}</div>
              <div className="stat-label">
                <span className="stat-label-full">Actualizado (cada {getRefreshIntervalText(refreshInterval)})</span>
                <span className="stat-label-short">Hace</span>
              </div>
            </div>
          </div>
          <div className="stat-item">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <div className="stat-value">{messageCount}</div>
              <div className="stat-label">Mensajes</div>
            </div>
          </div>
          <div className="stat-item">
            <div className="stat-icon">📈</div>
            <div className="stat-content">
              <div className="stat-value">{historyLength}</div>
              <div className="stat-label">
                <span className="stat-label-full">En Historial</span>
                <span className="stat-label-short">Historial</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
